
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import styled, { css } from 'styled-components';

const StyledGrid = styled.div`
  display: grid;
  
  ${props => props.columns && css`
    grid-template-columns: ${props.columns};
  `};
  
  ${props => props.gapSize && css`grid-gap: ${props.gapSize}px;`};
  
  ${props => props.rows && css`
    grid-template-rows: ${props.rows};
  `};
  
  ${props => props.tabletColumns && css`
    @media (max-width: 1279px) and (min-width: 768px) {
      grid-template-columns: ${props.tabletColumns};
    }
  `};
  
  ${props => props.mobileColumns && css`
    @media (max-width: 767px) {
      grid-template-columns: ${props.mobileColumns};
    }
  `};
`;


export class Grid extends Component {

  static propTypes = {
    columns: PropTypes.string,
    rows: PropTypes.string,
    mobileColumns: PropTypes.string,
    tabletColumns: PropTypes.string
  }

  static defaultProps = {
    gapSize: 10
  }

  render() {
    return (
      <StyledGrid {...this.props}>{this.props.children}</StyledGrid>
    )
  }
}
